import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useOsloClock } from '@/hooks/use-oslo-clock'

interface OpenStatusProps {
    className?: string
}

/** Live office status in Oslo time. Shows the opening hours until the clock is known. */
export const OpenStatus: FC<OpenStatusProps> = ({ className }): ReactNode => {
    const { time, open } = useOsloClock()

    return (
        <p className={cn('inline-flex items-center gap-3 text-sm', className)}>
            <span className='relative flex size-2.5 items-center justify-center' aria-hidden='true'>
                <span className={cn('absolute inset-0 rounded-full', open ? 'pulse-dot bg-lime' : 'bg-current opacity-40')} />
                <span className={cn('relative size-2 rounded-full', open ? 'bg-lime' : 'bg-current opacity-60')} />
            </span>

            {time === null && <span>Ekte folk på telefonen, hverdager 08 til 16</span>}

            {time !== null && (
                <span>
                    <span className='t-label mr-2 tabular opacity-70'>Oslo {time}</span>
                    {open ? 'Vi sitter klare på telefonen nå' : 'Telefonen er åpen hverdager 08 til 16'}
                </span>
            )}
        </p>
    )
}
